// @flow
import { connect } from "react-redux";

import { push, replace, go, goBack, goForward } from "./RouterActions";

import type { Location, LocationShape } from "react-router";
import type {
  PushAction,
  ReplaceAction,
  GoAction,
  GoBackAction,
  GoForwardAction,
} from "./types";
import type { ComponentType } from "react";
import type { ReduxState } from "../types";

type WithKeyStateProps = { locationKey: string, ... };

type WithPathnameProps = { pathname: string, ... };

type WithLocationProps = { location: Location, ... };

type WithQuerystringProps = { querystring: string, ... };

type NavigationDispatchProps = {
  push: (location: LocationShape | string, state?: { ... }) => PushAction,
  replace: (location: LocationShape | string, state?: { ... }) => ReplaceAction,
  go: (delta: number) => GoAction,
  goBack: () => GoBackAction,
  goForward: () => GoForwardAction,
};

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useLocationKey' instead
 */
const withKey: ComponentType<any> = connect<WithKeyStateProps, {}, _, _, _, _>(
  (state: ReduxState) => ({
    locationKey: state.router.location?.key ?? "",
  }),
);

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'usePathname' instead
 */
const withPathname: ComponentType<any> = connect<
  WithPathnameProps,
  {},
  _,
  _,
  _,
  _,
>((state: ReduxState) => ({
  pathname: state.router.location?.pathname,
}));

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useLocation' instead
 */
const withLocation: ComponentType<any> = connect<
  WithLocationProps,
  {},
  _,
  _,
  _,
  _,
>((state: ReduxState) => ({
  location: state.router.location,
}));

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useQuerystring' instead
 */
const withQuerystring: ComponentType<any> = connect<
  WithQuerystringProps,
  {},
  _,
  _,
  _,
  _,
>((state: ReduxState) => ({
  querystring: state.router.location?.search,
}));

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useNavigation' instead
 */
const withNavigation: ComponentType<any> = connect<
  NavigationDispatchProps,
  {},
  _,
  _,
  _,
  _,
>(null, {
  push,
  replace,
  go,
  goBack,
  goForward,
});

export { withKey, withPathname, withLocation, withQuerystring, withNavigation };
